import { render } from "./ClassicCodeView.vue?vue&type=template&id=10a5fc2e"
import script from "./ClassicCodeView.vue?vue&type=script&lang=js"
export * from "./ClassicCodeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__